<template>
  <div class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300" style="background-color: #242127">
    <div class="p-6 text-left">
      <h3 v-if="title" class="text-xl font-semibold text-gray-200 mb-4">{{ title }}</h3>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardCard',
  props: {
    title: {
      type: String,
      default: null
    },
  }
}
</script>

<style scoped>

</style>